export default "__VITE_ASSET__CBdCrzkL__"